// removed by extract-text-webpack-plugin
module.exports = {"list":"_3iu7uI3hULv7YqYBFQPnbx","item":"_2hWrmSNWhand6fwXGAERFg","image":"mrj4JbWwrQxslJuW7U25b","link":"_do9rTHUJzRM2IxRXNL59","link_active":"_1Qq2Rs3FEfDT8HprQ20Eja","shake":"_3gDSzK5mu7K_twqNy2qtV1"};


//////////////////
// WEBPACK FOOTER
// ../components/Menu/style.module.less
// module id = 392
// module chunks = 0